import { logEvent } from 'firebase/analytics';
import { analytics } from '../config/firebase';

// Generic event tracking function
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, parameters);
      console.log(`Analytics Event: ${eventName}`, parameters);
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }
};

// Page tracking
export const trackPageView = (pageName: string, additionalParams?: Record<string, any>) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...additionalParams
  });
};

// Category interactions
export const trackCategoryView = (categoryId: string) => {
  trackEvent('view_category', {
    category_id: categoryId,
    content_type: 'category'
  });
};

// Coloring game events
export const trackColoringStart = (categoryId: string, imageId: string) => {
  trackEvent('coloring_start', {
    category_id: categoryId,
    image_id: imageId,
    content_type: 'coloring_page',
    event_category: 'Game',
    event_label: `${categoryId}/${imageId}`
  });
};

export const trackColoringComplete = (categoryId: string, imageId: string, timeSpent: number) => {
  trackEvent('coloring_complete', {
    category_id: categoryId,
    image_id: imageId,
    time_spent_seconds: timeSpent,
    content_type: 'coloring_page',
    event_category: 'Game',
    event_label: `${categoryId}/${imageId}`,
    value: 1
  });
};

// Color selection tracking
export const trackColorSelection = (colorHex: string, colorIndex?: number) => {
  trackEvent('color_selected', {
    color_hex: colorHex,
    color_index: colorIndex,
    event_category: 'Game',
    event_label: colorHex
  });
};

// Settings and preferences
export const trackSettingsChange = (settingName: string, settingValue: string | number | boolean) => {
  trackEvent('settings_change', {
    setting_name: settingName,
    setting_value: settingValue.toString(),
    event_category: 'Settings'
  });
};

// Game engagement events
export const trackGameEngagement = (action: string, details?: Record<string, any>) => {
  trackEvent('game_engagement', {
    engagement_action: action,
    event_category: 'Engagement',
    ...details
  });
};

// User interaction events
export const trackUserInteraction = (interactionType: string, details?: Record<string, any>) => {
  trackEvent('user_interaction', {
    interaction_type: interactionType,
    event_category: 'User_Action',
    ...details
  });
};

// Progress tracking
export const trackProgress = (progressType: string, progressValue: number, maxValue?: number) => {
  trackEvent('progress_update', {
    progress_type: progressType,
    progress_value: progressValue,
    max_value: maxValue,
    progress_percentage: maxValue ? Math.round((progressValue / maxValue) * 100) : 0,
    event_category: 'Progress'
  });
};

// Error tracking
export const trackError = (errorType: string, errorMessage: string, errorLocation?: string) => {
  trackEvent('app_error', {
    error_type: errorType,
    error_message: errorMessage,
    error_location: errorLocation,
    event_category: 'Error'
  });
};

// Performance tracking
export const trackPerformance = (performanceType: string, duration: number, details?: Record<string, any>) => {
  trackEvent('performance_metric', {
    performance_type: performanceType,
    duration_ms: duration,
    event_category: 'Performance',
    ...details
  });
}; 